import { useSelector } from "react-redux"
import { DotPill, Tone } from "../../../components/delivery/atoms"
import { IGeneral } from "../../../store/General"

type CatalogEntry = { code: string; name?: string; sentName?: string | null; color?: string | null }

/** Catalog colours are CSS names or hex; the canvas pill only has five tones. */
function toneOf(color?: string | null): Tone {
  const c = (color ?? "").toLowerCase()
  if (/green|teal|lime/.test(c)) return "green"
  if (/red|pink/.test(c)) return "red"
  if (/yellow|orange|amber/.test(c)) return "amber"
  if (/blue|violet|indigo|cyan|grape/.test(c)) return "blue"
  const hex = /^#([0-9a-f]{6})$/.exec(c)
  if (hex) {
    const n = parseInt(hex[1], 16)
    const r = (n >> 16) & 255, g = (n >> 8) & 255, b = n & 255
    const max = Math.max(r, g, b), min = Math.min(r, g, b)
    if (max - min < 24) return "grey"
    if (max === r) return g > 110 ? "amber" : "red"
    if (max === g) return "green"
    return "blue"
  }
  return "grey"
}

type Props = {
  code: string | null | undefined
  pick: (s: IGeneral) => CatalogEntry[]
  labelField?: "name" | "sentName"
}

/** Soft dot pill for the sales list (canvas Ord_SalesList): tinted background + coloured dot, dark text. */
export function StatusPill({ code, pick, labelField = "name" }: Props) {
  const catalog = useSelector((s: { general: IGeneral }) => pick(s.general)) ?? []
  const entry = catalog.find((c) => c.code === code)
  const label = (labelField === "sentName" ? entry?.sentName : entry?.name) ?? "-"
  return <DotPill tone={entry ? toneOf(entry.color) : "grey"}>{label}</DotPill>
}

export const orderStatusPill = (code: string | null | undefined) => (
  <StatusPill code={code} pick={(g) => g.orderStatus as CatalogEntry[]} labelField="sentName" />
)
export const paymentStatusPill = (code: string | null | undefined) => (
  <StatusPill code={code} pick={(g) => g.paymentStatus as CatalogEntry[]} />
)
